import { ButtonView } from '@vivli/shared/views';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';
import { useActiveUserContext, useAssignedAppTypeContext, useModalApiContext } from '@vivli/core/infrastructure/context';
import { useNavigate } from 'react-router';
import { DTICommonConst } from '@vivli/shared/infrastructure/constants';

export const EditDataRequestButtonView = () => {
    const navigate = useNavigate();
    const { dataRequest, isUpdatingStatus } = useDataRequestContext();
    const modalService = useModalApiContext();
    const { isAmr } = useAssignedAppTypeContext();
    const { hasPermission } = useActiveUserContext();

    const handleEditClick = () => {
        var isVivliAdmin = hasPermission(PermissionsEnum.DrActAdv);
        //TODO PERMFE - redo with permissions+
        const linkTab = !isAmr ? 'researchProposal' : isVivliAdmin ? 'requestprintview' : 'request';
        modalService.confirm('Proceeding will take you to the edit form for this data request. Proceed?', {
            title: 'Confirm Override?',
            onConfirm: () => {
                //TODO PERMFE - redo with permissions+
                navigate(`/myDataRequestDetails/${dataRequest.id}/${linkTab}`, {
                    state: { detail: isVivliAdmin },
                });
            },
        });
    };

    return (
        <ButtonView dataId={DTICommonConst.EditButton} style={{ marginLeft: 10 }} onClick={handleEditClick} disabled={isUpdatingStatus}>
            Edit Data Request
        </ButtonView>
    );
};
